import {
  fetchEventSource,
  type FetchEventSourceInit,
} from '@microsoft/fetch-event-source'

import { claimStoredTokens } from './tokens'

export function getApiEventSourceClient() {
  const baseURL = process.env['NEXT_PUBLIC_API_URL']

  const headers: Record<string, string> = {
    'Accept-Language': 'pt',
  }

  if (typeof window !== 'undefined') {
    const { bearerToken, idToken } = claimStoredTokens()

    if (bearerToken) {
      headers['Authorization'] = `Bearer ${bearerToken}`
    }

    if (idToken) {
      headers['Auth0-IdToken'] = idToken
    }

    headers['Accept-Language'] = localStorage.getItem('lang') ?? 'pt'
  }

  function get(path: string, options?: FetchEventSourceInit) {
    return fetchEventSource(`${baseURL}/${path}`, {
      ...options,
      openWhenHidden: true,
      headers,
      method: 'GET',
    })
  }

  function post() {
    throw Error('Not implemented yet.')
  }

  function put() {
    throw Error('Not implemented yet.')
  }

  function delete_() {
    throw Error('Not implemented yet.')
  }

  return { get, post, put, delete: delete_ }
}
